<template>
  <v-card id="readopcard" max-width="350" width="100%" color="lsidebg" class="mb-3 mr-sm-3 mr-md-0 pb-1 d-print-none lside-wdgt" flat>   
    <v-card-title class="pt-2 pb-1 pl-2">
      <h5 class="wdgt-title ">{{$t('database.wdg_lang')}} </h5> <!--darkgrey--text-->
    </v-card-title>
    <v-card-text class="pt-0 pb-1">
      <v-col class="flex-wrap px-0 py-0">
        <v-btn
          v-for="opt in noCurLangOpts"
          :key="opt"
          dense
          outlined
          small
          color="link"
          class="mr-2 mb-2" 
          @click="$emit('go_trans', opt)"
        > 
          {{LANGS[opt]}}
        </v-btn>
      </v-col>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    name: 'LangOpts',
    props: {
      options: Array,  // Can include current language.
      curLang: String  // Will be removed from options.
    },
    data(){
      return {
        LANGS: {en: 'English', tc: '繁體中文', sc: '简体中文'}
      }
    },
    computed: {
      noCurLangOpts: function(){
        return this.options.filter(opt => opt !== this.curLang)
      }
    }
  }
</script>